// Floating, resizable, non-modal window showing a single TRQ document's raw
// notes (the main order, or any related/child document — return/replacement/
// RMA/etc.) — replaces reliance on the AI-summarized version buried in the
// drafted reply's grounding. Deliberately a fresh, unfiltered read (see
// routes/conversations.js's GET /:id/notes) rather than a reuse of
// enrichment.js's extractNoteTexts() filtering/collapsing logic.
//
// The floating-window shell itself (react-rnd drag/resize, no MUI Dialog/
// backdrop) now lives in the shared DraggableModal.jsx, generalized from the
// pattern this file originally introduced — this component is just that
// shell plus the title. The actual fetch-and-render logic lives in
// NotesList.jsx, shared with DocumentDetailWindow.jsx's own Notes section.
import DraggableModal from './DraggableModal.jsx'
import NotesList from './NotesList.jsx'

// Notepad icon for the header trigger buttons (Order ID field, each related
// document row) — exported so App.jsx can use the same icon on the buttons
// that open a window, without duplicating the SVG.
export function NotepadIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
      <path d="M9 8h6M9 12h6M9 16h4" />
    </svg>
  )
}

const DEFAULT_WIDTH = 700
const DEFAULT_HEIGHT = 700

// conversationId/erpOrderId: which document's notes to fetch. title: shown in
// the drag-handle header (e.g. "Notes — ORD102477233" or "Notes —
// RTN01176305 (Return)"). offsetIndex: this window's position in the
// currently-open list, used to stagger the default x/y. onClose: called with
// no args when the CSR dismisses this window.
export default function OrderNotesWindow({ conversationId, erpOrderId, title, offsetIndex = 0, onClose }) {
  return (
    <DraggableModal
      open
      onClose={onClose}
      title={title}
      offsetIndex={offsetIndex}
      width={DEFAULT_WIDTH}
      height={DEFAULT_HEIGHT}
      minWidth={260}
      minHeight={200}
      contentSx={{ p: 1.5 }}
    >
      <NotesList conversationId={conversationId} erpOrderId={erpOrderId} />
    </DraggableModal>
  )
}
